<template>
	<div>

		<div>
			<!-- BEGIN panel -->
			<div v-show="!tasks.length" class="text-center">
				<h3> Все заказы проверены</h3>
			</div>

			<div class="card  border-0 mb-3" v-for="(task, index)  in tasks" :key="index">

				<TaskShow :task="task" />
				<div class="card-footer">
					<div class="justify-content-end" style="display: flex;justify-content: right;">
						<div>
							<button @click="$router.push(`/task/${task.id}/review`);" class="btn btn-info btn-xs me-2">
								<i class="fas  fa-circle-exclamation"></i> Модерация</button>
							<button @click="$router.push(`/task/${task.id}/edit`);"
								class="btn btn-white btn-xs me-2">Редактировать</button>
							<button @click="removeTask(task.id)" class="btn btn-white btn-xs">Удалить</button>
						</div>
					</div>
				</div>
			</div>
			<!-- END panel -->
		</div>
	</div>
</template>


<script>
import HTTP from "../http";
import { show_error, show_message } from "../message";

export default {

	data() {
		return {
			loading: false,
			tasks: []
		};
	},


	mounted() {
		this.fetchData();
	},
	methods: {
		removeTask(id) {
			if (confirm("Вы уверены? ")) {
				HTTP()
					.delete("v2/task/" + id)
					.then((response) => {
						console.log(response);
						show_message(this.$notify, response.data);
						this.fetchData();
					})
					.catch((error) => {
						show_error(this.$notify, this.$refs.form, error.response.data)
					});
			}
			return;
		},
		fetchData() {
			this.loading = true;
			this.$insProgress.start();
			HTTP()
				.get("/task?moderate")
				.then((resp) => {
					console.log('resp', resp)
					this.tasks = resp.data
				})
				.catch((error) => {
					show_error(this.$notify, this.$refs.form, error.response.data)
				})
				.finally(() => {
					this.loading = false;
					this.$insProgress.finish();
				});
		},
	}
}
</script>


<style>
.task-href {
	cursor: pointer;
	text-decoration: none;
	color: var(--bs-body-color);
}

.task-href:visited {
	color: var(--bs-body-color);
}

.task-href:hover {
	color: var(--bs-body-color);
}
</style>